(() => {
  document.querySelectorAll('[data-rv-home-carousel]').forEach((carousel) => {
    if (carousel.dataset.rvHomeReady) return;
    carousel.dataset.rvHomeReady = 'true';
    const track = carousel.querySelector('[data-rv-home-track]');
    const slides = Array.from(track.children);
    const dots = Array.from(carousel.querySelectorAll('[data-rv-home-dot]'));
    const previous = carousel.querySelector('[data-rv-home-prev]');
    const next = carousel.querySelector('[data-rv-home-next]');
    let active = 0;

    const update = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => { slide.inert = slideIndex !== active; });
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const goTo = (index) => {
      update(index);
      track.scrollTo({ left: slides[active].offsetLeft - track.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    update(0);
    previous.addEventListener('click', () => goTo(active - 1));
    next.addEventListener('click', () => goTo(active + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    track.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      if (index !== active && index >= 0 && index < slides.length) update(index);
    }, { passive: true });
  });
})();
